import React from "react"
import { sanitizeInnerHtml } from "@/utils/helper"
const TextFiller = props => {
  
  const {
    data: { text = "", appliedCssClassNames = "" } = {},
  } = props

  return (
    <div className={`text ${appliedCssClassNames ? appliedCssClassNames : ""}`}>
        <div className="cmp-text">{sanitizeInnerHtml(text)}</div>
    </div>
  )
}

export default TextFiller
